module.exports = __webpack_public_path__ + "img/ComparePrices.373f0bb4.png";